
var api = {
  //  baseurl:'http://111.33.181.195:18010/admin',
   baseurl:'/api',
  //  gxjUrl:'https://gxj.yctech100.cn/',//xue：部署到195的地址
   gxjUrl:'https://wqqyfw.cn/',//xue：部署到正式环境的地址
   
    imageUrl:'/system_resources/uploadFile/', //预览图片
    // imageUrl:'http://111.33.181.195:18012/system_resources/uploadFile/', //预览图片
    // imageUrl:'http://111.33.181.195:18011/uploadFile/', //预览图片
//    imageUrl:'http://192.168.18.203:18011/uploadFile/', 
//    imageUrl:'http://192.168.18.86:18011/uploadFile/', 
   
  docUrl:'/system_resources/attachment_template/'
  // docUrl:'http://111.33.181.195:18012/system_resources/attachment_template/'
}
export default api  